import React from 'react';
import { Link } from 'react-router-dom';
import './ListEntry.css';

import playIco from '../../../../../../assets/img/play-over.png';
import frameVideo from '../../../../../../assets/img/frame-video.png';
import defaultImg from '../../../../../../assets/img/entry-default.jpg';
import icoVideo from '../../../../../../assets/img/ico-type-video.png';
import icoImage from '../../../../../../assets/img/ico-type-image.png';
import { ENTRY_TYPE, ROUTING } from '../../../../../../constants';

// todo - generate thumbs for images types on upload and use them for type 2

class ListEntry extends React.Component {
  getImgVideo() {
    if (
      this.props.entryData.programme.data.programme &&
      this.props.entryData.programme.data.programme.imageURL
    ) {
      // todo - probably move parse + replace to back
      // todo - find out if there isn't any more suitable size than 400
      // todo - check new image dimensions
      // return this.props.entryData.programme.data.programme.imageURL.replace('w140', 'w400');
      // todo - replace removed for now - 400 is not available everywhere - check why with Jakub
      return this.props.entryData.programme.data.programme.imageURL.replace(/https:|http:/g,'');
    }
    return '';
  }

  getImgGallery() {
    if (this.props.entryData.galleryOrder.length > 0) {
      return `https://storage.googleapis.com/stoleti-img/${
        this.props.entryData.gallery[this.props.entryData.galleryOrder[0]].img
      }-thumb.jpg`;
    }
    return '';
  }

  getEntryType() {
    // todo - move to api parse
    // todo - move parse to data load
    // todo - just quick parse - revise
    // todo - videoURL shouldn't be array - parse probably on backend
    if (
      this.props.entryData.programme.data.programme &&
      this.props.entryData.programme.data.programme.videoURL &&
      this.props.entryData.programme.data.programme.videoURL.indexOf('http') !==
        -1
    ) {
      return ENTRY_TYPE.VIDEO;
    } else if (this.props.entryData.galleryOrder.length > 0) {
      return ENTRY_TYPE.GALLERY;
    }
    return null;
  }

  defaultImg(e) {
    e.target.src = defaultImg;
  }

  getLinkContent(entryType, icoType) {
    const { tip } = this.props;

    // todo - quick raw implementation
    let timeClass = 'time';
    if (!tip) {
      timeClass += ' normal';
    }

    // todo - raw implementation
    return (
      <React.Fragment>
        {tip && <div className="tip-head">Tip dne</div>}
        <div className={timeClass}>{this.props.entryData.timeData.time}</div>
        {icoType !== null && (
          <img className="ico-type" src={icoType} alt="Typ" />
        )}
        <h4>{this.props.entryData.title}</h4>
        {entryType === ENTRY_TYPE.VIDEO && (
          <div className="thumb">
            <img
              onError={this.defaultImg}
              src={this.getImgVideo()}
              alt={this.props.entryData.title}
            />
            <img className="frame" src={frameVideo} alt="TV frame" />
            <img className="ico-play" src={playIco} alt="Play" />
          </div>
        )}
        {entryType === ENTRY_TYPE.GALLERY && (
          <div className="thumb">
            <img
              onError={this.defaultImg}
              src={this.getImgGallery()}
              alt={this.props.entryData.title}
            />
          </div>
        )}
        {this.props.entryData.desc !== '' &&
          !tip && <div>{this.props.entryData.desc}</div>}
        {this.props.entryData.note !== '' &&
          !tip && <div className="note">{this.props.entryData.note}</div>}
      </React.Fragment>
    );
  }

  getEntryContent() {
    // todo - raw implementation
    const entryType = this.getEntryType();
    let className = 'list-entry';
    let icoType = null;

    if (entryType) {
      className = `${className} type-${entryType}`;
      icoType = entryType === ENTRY_TYPE.VIDEO ? icoVideo : icoImage;
    }

    if (this.props.tip) {
      className = `${className} tip`;
    }

    const route = `${ROUTING.DETAIL}/${this.props.entryData.key}/${
      this.props.entryData.timeData.key
    }`;

    if (entryType) {
      // link
      return (
        <Link className={className} to={route}>
          {this.getLinkContent(entryType, icoType)}
        </Link>
      );
    }
    // inactive
    return (
      <div className={className}>{this.getLinkContent(entryType, icoType)}</div>
    );
  }

  render() {
    return this.getEntryContent();
  }
}

export default ListEntry;



// WEBPACK FOOTER //
// ./src/components/App/Program/List/DayList/ListEntry/ListEntry.js